/**
 * Utility functions for farmer data
 * Aligned with Django Farmer model
 */

// Define constants for dropdown options
export const GENDER_CHOICES = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'others', label: 'Others' }
];

export const LAND_STATUS_CHOICES = [
  { value: 'Own', label: 'Own' },
  { value: 'Rented', label: 'Rented' },
  { value: 'Leased', label: 'Leased' },
  { value: 'Others', label: 'Others' }
];

export const SOCIAL_CATEGORY_CHOICES = [
  { value: 'OC', label: 'OC' },
  { value: 'SC', label: 'SC' },
  { value: 'ST', label: 'ST' },
  { value: 'BC', label: 'BC' }
];

export const LIVELIHOOD_CHOICES = [
  { value: 'Farmer', label: 'Farmer' },
  { value: 'Private employee', label: 'Private employee' },
  { value: 'government employee', label: 'Government employee' }
];

export const CROPPING_SEASON_CHOICES = [
  { value: 'karif', label: 'Karif' },
  { value: 'rabi', label: 'Rabi' },
  { value: 'zaid', label: 'Zaid' }
];

export const CROPPING_PATTERN_CHOICES = [
  { value: 'Mono cropping', label: 'Mono cropping' },
  { value: 'Inter Cropping', label: 'Inter Cropping' },
  { value: 'Sequential Cropping', label: 'Sequential Cropping' },
  { value: 'Crop rotation', label: 'Crop rotation' },
  { value: 'Relay Cropping', label: 'Relay Cropping' }
];

export const FARMING_PRACTICE_CHOICES = [
  { value: 'Conventional', label: 'Conventional' },
  { value: 'Natural farming', label: 'Natural farming' },
  { value: 'Regenerative', label: 'Regenerative' },
  { value: 'Sustainable Agriculture', label: 'Sustainable Agriculture' },
  { value: 'Zero tillage', label: 'Zero tillage' },
  { value: 'Multi / Inter Cropping', label: 'Multi / Inter Cropping' }
];

export const CROP_TYPE_CHOICES = [
  { value: 'Food crops', label: 'Food crops' },
  { value: 'Feed Crops', label: 'Feed Crops' },
  { value: 'Fiber crops', label: 'Fiber crops' },
  { value: 'Oil crops', label: 'Oil crops' },
  { value: 'Ornamental crops', label: 'Ornamental crops' },
  { value: 'Industrial crops', label: 'Industrial crops' }
];

export const SOIL_TYPE_CHOICES = [
  { value: 'Sandy soil', label: 'Sandy soil' },
  { value: 'Clayey soil', label: 'Clayey soil' },
  { value: 'Silty soil', label: 'Silty soil' },
  { value: 'Loamy soil', label: 'Loamy soil' },
  { value: 'Peat soil', label: 'Peat soil' },
  { value: 'Chalky soil', label: 'Chalky soil' },
  { value: 'Alluvial soil', label: 'Alluvial soil' },
  { value: 'Red Soil', label: 'Red Soil' },
  { value: 'Black soil', label: 'Black soil' },
  { value: 'Laterite soil', label: 'Laterite soil' }
];

export const SOIL_PH_CHOICES = [
  { value: 'pH <= 5.5', label: 'pH ≤ 5.5' },
  { value: '5.5 < pH <= 7.3', label: '5.5 < pH ≤ 7.3' },
  { value: '7.3 < pH <= 8.5', label: '7.3 < pH ≤ 8.5' },
  { value: 'pH > 8.5', label: 'pH > 8.5' }
];

export const FERTILIZER_TYPE_CHOICES = [
  { value: 'Fertilizer Application N', label: 'Fertilizer Application N' },
  { value: 'Fertilizer Application P&K', label: 'Fertilizer Application P&K' },
  { value: 'Organic fertilizer', label: 'Organic fertilizer' }
];

export const PESTICIDE_CATEGORY_CHOICES = [
  { value: 'Pesticide', label: 'Pesticide' },
  { value: 'Fungicide', label: 'Fungicide' }
];

export const ENERGY_USE_CHOICES = [
  { value: 'diesel', label: 'Diesel' },
  { value: 'petrol', label: 'Petrol' },
  { value: 'electricity (grid)', label: 'Electricity (grid)' },
  { value: 'fuel wood', label: 'Fuel wood' },
  { value: 'coal', label: 'Coal' }
];

export const ENERGY_UNIT_CHOICES = [
  { value: 'kg', label: 'kg' },
  { value: 'lit', label: 'lit' },
  { value: 'kWh', label: 'kWh' }
];

export const WATER_SOURCE_CHOICES = [
  { value: 'Natural lake/pond', label: 'Natural lake/pond' },
  { value: 'Reservoir', label: 'Reservoir' },
  { value: 'River/Stream/ditch', label: 'River/Stream/ditch' },
  { value: 'Borehole/well', label: 'Borehole/well' },
  { value: 'On farm storage pond/tank', label: 'On farm storage pond/tank' }
];

export const IRRIGATION_METHOD_CHOICES = [
  { value: 'Drip', label: 'Drip' },
  { value: 'Pivot', label: 'Pivot' },
  { value: 'Rain gun', label: 'Rain gun' },
  { value: 'Flooding', label: 'Flooding' }
];

export const TRANSPORT_ACTIVITY_CHOICES = [
  { value: 'Fuel consumption', label: 'Fuel consumption' },
  { value: 'Distance travelled', label: 'Distance travelled' }
];

export const TRANSPORT_MODE_CHOICES = [
  { value: 'Road LDV (<3.5 T)', label: 'Road LDV (<3.5 T)' },
  { value: 'Road MDV (<12 T)', label: 'Road MDV (<12 T)' },
  { value: 'Road hDV (>12 T)', label: 'Road hDV (>12 T)' },
  { value: 'Two wheeler', label: 'Two wheeler' },
  { value: 'Three Wheeler', label: 'Three Wheeler' }
];

export const FUEL_TYPE_CHOICES = [
  { value: 'Petrol', label: 'Petrol' },
  { value: 'Diesel', label: 'Diesel' },
  { value: 'CNG', label: 'CNG' }
];

// Farmer data structure model
// Create default farmer data structure aligned with Django model
export const createFarmerData = () => ({
  id: Date.now().toString(),
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  sync_status: 'pending',
  is_read_only: false,

  // Farmer Information
  farmer_name: '',
  spouse_name: '',
  gender: '',
  mobile: '',
  alt_mobile: '',
  govt_id: '',

  // Land Information
  acreage: '',
  land_status: '',
  product_ids: '',

  // Location Information
  village: '',
  mandal: '',
  district: '',
  state: '',
  pincode: '',

  // Organization Information
  has_organization: false,
  fpo_name: '',
  fpg_name: '',
  fpg_id: '',

  // Social Information
  category: '',
  literacy: '',
  children: '',
  livelihood: '',
  annual_income: '',
  other_source_income: '',
  total_income: '',

  // Crop Information
  crop_name: '',
  crop_area: '',
  crop_area_unit: 'acres',
  yield_produced: '',
  yield_unit: 'kg',
  cropping_season: '',
  cropping_pattern: '',
  farming_practice: '',
  agriculture_crop_type: '',

  // Soil Characteristics
  soil_type: '',
  soil_ph: '',
  ec: '',
  ec_unit: 'dS/m',
  organic_carbon: '',
  organic_carbon_unit: '%',

  // Fertilizer
  fertilizer_type: '',
  application_rate: '',
  application_rate_unit: 'kg/ha',

  // Crop Protection
  pesticide_category: '',
  pesticide_application_rate: '',
  pesticide_application_rate_unit: 'kg/ha',

  // Fuel & Energy
  direct_energy_use: '',
  energy_used: '',
  energy_unit: 'kWh',
  energy_category: '',

  // Irrigation
  water_source: '',
  irrigation_method: '',
  power_source: '',
  power_consumption: '',
  power_consumption_unit: 'kWh',

  // Transport
  transport_activity_type: '',
  transport_mode: '',
  distance: '',
  distance_unit: 'km',
  fuel_type: '',
  fuel_consumption: '',
  fuel_consumption_unit: 'lit',
  // Media Files
  farmer_photo: null,
  land_photo_1: null,
  land_photo_2: null,
  land_photo_3: null,
  land_photo_4: null,
  soil_characteristics: null,
  fertilizer_photos: null,
  crop_protection_photos: null
});

// Constants
export const FARMERS_STORAGE_KEY = '@farmer_connect_farmers';
